import { render, staticRenderFns } from "./Bankkbank.vue?vue&type=template&id=531951b3"
import script from "./Bankkbank.vue?vue&type=script&lang=js"
export * from "./Bankkbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports